import * as React from "react";
import Box from "@mui/material/Box";
import SearchIcon from "@mui/icons-material/Search";

export default function CompareMain(props) {
    const { setSearchValue } = props;

    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                width: {
                    xs: "300px",
                    sm: "260px",
                    md: "260px",
                    lg: "380px",
                    xl: "320px",
                },
                height: 38,
                boxSizing: "border-box",
                backgroundColor: "var(--primary-popup-background-color)",
                border: "1px solid var(--primary-theme-color)",
                borderRadius: "6px",
                paddingLeft: "10px",
                paddingRight: "12px",
                "&:focus-within": {
                    borderColor: "var(--primary-theme-color)",
                },
                "& input": {
                    flex: 1,
                    minWidth: 0,
                    border: 0,
                    margin: 0,
                    outline: 0,
                    backgroundColor: "transparent",
                    color: "var(--primary-text-color)",
                    fontFamily: "Poppins, sans-serif",
                    fontSize: "14px",
                    height: "100%",
                    lineHeight: 1.2,
                    "&::placeholder": {
                        color: "var(--primary-text-color-80)",
                        opacity: 1,
                    },
                },
            }}
        >
            <SearchIcon
                sx={{
                    color: "var(--primary-text-color)",
                    fontSize: 20,
                    flexShrink: 0,
                    mr: "8px",
                }}
            />
            <input
                type="search"
                placeholder="Search by name"
                title="Separate multiple names with spaces"
                onChange={(e) =>
                    setSearchValue?.(e.target.value)
                }
                autoComplete="off"
            />
        </Box>
    );
}
